<!--
 * @Author: your name
 * @Date: 2021-12-23 11:15:07
 * @LastEditTime: 2022-03-08 17:24:48
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\components\explorer\NewMediaList\FileList.vue
-->
<template>
  <ul class="file-list">
    <li class="is-selected flex-c-c">
      <el-checkbox v-model="fileChecked" @change="checkboxChange" :disabled="file.group_dir !== 0"></el-checkbox>
    </li>
    <li class="attr flex-c" @dblclick="openFile">
      <img class="m-img" :src="imageRequire(file.group_dir?'fileLock':'file')" alt />
      <span class="ellipsis-1">{{file.name}}</span>
    </li>
    <li class="attr flex-c">
      <span style="padding-left: 16px;">--</span>
    </li>
    <li class="attr flex-c">--</li>
    <li class="attr flex-c">{{file.create_time}}</li>
    <li class="attr flex-a-c">
      <img class="icon" src="@imgpub/move.png" @click="handleFile('move')" :title="$t('explorer.move')" />
      <img class="icon" src="@imgpub/public_copy.png" @click="handleFile('copy')" :title="$t('explorer.copy')" />
      <img class="icon" src="@imgpub/public_delete.png" @click="handleFile('del')" :title="$t('explorer.delete')" />
    </li>
  </ul>
</template>

<script>
export default {
  name: "FileList",
  props: {
    file: {
      type: Object,
      required: true,
      default: () => { }
    },
    isSelected: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      fileChecked: false,
    }
  },
  methods: {
    checkboxChange(val) {
      // console.log(val);
      this.$emit("setSelectFile", val, this.file.id);
    },
    imageRequire(type) {
      switch (type) {
        case "file": return require("@/assets/images/program/public_file.png");
        case "fileLock": return require("@/assets/images/program/public_file_lock.png");
        default:
          break;
      }
    },
    openFile() {
      this.$emit("setFileGroupId", this.file.group_id, this.file.id);
    },
    handleFile(type) {
      switch (type) {
        case "move":
          this.$emit("setFileMoveId", this.file.id, "move");
          break;
        case "share":
          break;
        case "copy":
          this.$emit("setFileMoveId", this.file.id, "copy");
          break;
        case "del":
          this.$emit("setDeleteFile", this.file.id);
          break;
        default:
          break;
      }
    }
  },
  watch: {
    isSelected: {
      handler(nVal) {
        this.fileChecked = nVal;
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.file-list {
  display: flex;
  justify-content: space-between;
  height: 56px;
  padding: 12px 0;
  border-top: 1px solid #ebeef5;
  .is-selected {
    width: 50px;
  }
  .attr {
    width: calc(20% - 10px);
    user-select: none;
    .m-img {
      height: 56px;
      user-select: none;
      margin: 0px 22px;
      cursor: pointer;
    }
    span {
      padding-left: 8px;
    }
    .icon {
      width: 30px;
      height: 30px;
    }
  }
  .attr:nth-child(2) {
    width: calc(20%);
  }
  .attr:last-child {
    width: calc(20% - 20px);
  }
}
</style>